var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "contact") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "#00A188",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-1717.000000, -35.000000)",
    stroke: "",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(1704.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,9.97009 L25,13.7088737 C25,18.6939187 22.5,21.1864412 17.5,21.1864412 L16.875,21.1864412 C16.4875,21.1864412 16.1124998,21.37338 15.8749998,21.6849453 L14,24.1774678 C13.1749997,25.2741777 11.8250003,25.2741777 11,24.1774678 L9.12500024,21.6849453 C8.92500024,21.4107678 8.46250001,21.1864412 8.125,21.1864412 L7.5,21.1864412 C2.5,21.1864412 0,19.94018 0,13.7088737 L0,7.4775675 C0,2.4925225 2.5,0 7.5,0 L15,0",
    id: "Vector",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875,6.23130625 C20.1491101,6.23130625 18.75,4.83638088 18.75,3.11565312 C18.75,1.39492537 20.1491101,2.84217094e-14 21.875,2.84217094e-14 C23.6008899,2.84217094e-14 25,1.39492537 25,3.11565312 C25,4.83638088 23.6008899,6.23130625 21.875,6.23130625 Z",
    id: "Vector",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.625,
    y1: 14.3320044,
    x2: 19.375,
    y2: 14.3320044,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.625,
    y1: 8.10069812,
    x2: 13.125,
    y2: 8.10069812,
    id: "Line-Copy"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.7926456d56f2a92f7e24d7b65e034782.svg";
export { ForwardRef as ReactComponent };